(function () {
  if (window.__giftWrapBound) return;
  window.__giftWrapBound = true;

  document.addEventListener('change', async function (e) {
    if (!e.target.classList.contains('js-gift-wrap-checkbox')) return;

    const checkbox = e.target;
    const wrap     = checkbox.closest('.gift-wrap');
    if (!wrap) return;

    const variantId = Number(wrap.dataset.giftVariantId);

    checkbox.disabled = true;
    try {
      const qty = checkbox.checked ? 1 : 0;

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [variantId]: qty } })
      });

      if (!response.ok) throw new Error('Cart update selhal: ' + response.status);
      const cart = await response.json();

      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'gift-wrap',
          data: { source: 'gift-wrap' }
        }
      }));

      checkbox.disabled = false;

    } catch (err) {
      console.error('Gift wrap error:', err);
      checkbox.checked = !checkbox.checked;
      checkbox.disabled = false;
      alert('Něco se pokazilo, zkuste to prosím znovu.');
    }
  });
})();